import { Component, OnInit, HostListener, ViewChild } from '@angular/core'; 
import { Router, NavigationEnd } from '@angular/router';
import { Settings, AppSettings } from '../app.settings';
import { AppService } from '../app.service';
import { Category, Product } from '../app.models';
import { SidenavMenuService } from '../theme/components/sidenav-menu/sidenav-menu.service';
import { PrincipalService } from '../shared/services/principal.service';
import { ViewCategory } from '../shared/model/viewCategory';
import { ViewArticle } from '../shared/model/viewArticle';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss'],
  providers: [ SidenavMenuService ]
})
export class PagesComponent implements OnInit {
  public showBackToTop:boolean = false; 
  public categories:ViewCategory[];
  public category:ViewCategory;
  public sidenavMenuItems:Array<any>;
  articulosBuscados:Array<ViewArticle>;
  @ViewChild('sidenav', { static: true }) sidenav:any;
  buscadorForms: FormGroup;
  buscadorMobileForm: FormGroup;
  public urlImage:string;
  public settings: Settings;
  constructor(public appSettings:AppSettings, 
              public appService:AppService, 
              public sidenavMenuService:SidenavMenuService,
              public router:Router,public principalService:PrincipalService) { 
    this.settings = this.appSettings.settings; 
  }

  ngOnInit() {
    this.urlImage = environment.imageServe; 
    this.getCategories();
    this.getValidations();
    this.buscadorForms.get('buscadorPrincipal').valueChanges.pipe()
    .subscribe(() => {
      this.getArticulos();
    });
    
    this.buscadorMobileForm.get('buscadorMobile').valueChanges.pipe()
    .subscribe(() => {
      this.getArticulosMobile();
    });
    //this.sidenavMenuItems = this.sidenavMenuService.getSidenavMenuItems();
    this.getMenu();
  } 
  
  getValidations() {
    this.buscadorForms = new FormGroup({
      buscadorPrincipal: new FormControl('', [
       
      ]),
    })

    this.buscadorMobileForm = new FormGroup({
      buscadorMobile: new FormControl('', [
       
      ]),
    })
  }
  
  getOptionText(option) {
    return option.name;
  }
  private getArticulosMobile() {
    console.log("a")
    if (typeof this.buscadorMobileForm.get('buscadorMobile').value === "string") {
      let text: string = this.buscadorMobileForm.get('buscadorMobile').value;
      if (text.trim().length > 3) {
        this.principalService.getSearchArticle(text).subscribe(
          (response => {
            this.articulosBuscados = response;
          }),
          (error => {
            console.log(error);
          })
        );
      }
    }
  }
  private getArticulos() {

    if (typeof this.buscadorForms.get('buscadorPrincipal').value === "string") {
      let text: string = this.buscadorForms.get('buscadorPrincipal').value;
      if (text.trim().length > 3) {
        this.principalService.getSearchArticle(text).subscribe(
          (response => {
            this.articulosBuscados = response;
          }),
          (error => {
            console.log(error);
          })
        );
      }
    }
  }

 
  public getMenu(){    
    this.principalService.getMenu().subscribe(data => {
      this.sidenavMenuItems = data;
      this.sidenavMenuService.expandActiveSubMenu(this.sidenavMenuItems);
      //this.category = data[0];
      //this.appService.Data.categories = data;
    })
  }

  public getCategories(){    
    /*this.appService.getCategories().subscribe(data => {
      this.categories = data;
      this.category = data[0];
      this.appService.Data.categories = data;
    })*/

    this.principalService.getCategorySeeker().subscribe(data => {
      this.categories = data;
      this.appService.Data.categories = data;
      this.category = data[0];
      
      //this.sidenavMenuItems = data;
    })
  }

  public changeCategory(event){
    if(event.target){
      this.category = this.categories.filter(category => category.name == event.target.innerText)[0];
    }
    if(window.innerWidth < 960){
      this.stopClickPropagate(event);
    } 
  }

  public remove(product) {
      const index: number = this.appService.Data.cartList.indexOf(product);
      if (index !== -1) {
          this.appService.Data.cartList.splice(index, 1);
          this.appService.Data.totalPrice = this.appService.Data.totalPrice - product.newPrice*product.cartCount;
          this.appService.Data.totalCartCount = this.appService.Data.totalCartCount - product.cartCount;
          this.appService.resetProductCartCount(product);
      }        
  }

  public clear(){
    this.appService.Data.cartList.forEach(product=>{
      this.appService.resetProductCartCount(product);
    });
    this.appService.Data.cartList.length = 0;
    this.appService.Data.totalPrice = 0;
    this.appService.Data.totalCartCount = 0;
  }
 

  public changeTheme(theme){
    this.settings.theme = theme;       
  }

  public stopClickPropagate(event: any){
    event.stopPropagation();
    event.preventDefault();
  }

  public search(){}

 
  public scrollToTop(){
    var scrollDuration = 200;
    var scrollStep = -window.pageYOffset  / (scrollDuration / 20);
    var scrollInterval = setInterval(()=>{
      if(window.pageYOffset != 0){
         window.scrollBy(0, scrollStep);
      }
      else{
        clearInterval(scrollInterval); 
      }
    },10);
    if(window.innerWidth <= 768){
      setTimeout(() => { window.scrollTo(0,0) });
    }
  }
  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event) {
    ($event.target.documentElement.scrollTop > 300) ? this.showBackToTop = true : this.showBackToTop = false;  
  }

  ngAfterViewInit(){
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) { 
        this.sidenav.close(); 
      }                
    });
    this.sidenavMenuService.expandActiveSubMenu(this.sidenavMenuService.getSidenavMenuItems());
  }

  public closeSubMenus(){
    if(window.innerWidth < 960){
      this.sidenavMenuService.closeAllSubMenus();
    }    
  }

}